import AuthHttpService from "./AuthHttpService";

import {
  IGifList,
  IAddToHistory,
  ITagsList,
  THistoryList,
  SearchGifsOrder,
} from "./types";

interface ISearchGifsRequest {
  query?: string;
  count: number;
  order: SearchGifsOrder;
  type?: string;
  page?: number;
  verified?: boolean;
  tags?: string[];
}

export default class SearchService extends AuthHttpService {
  public constructor(readonly url?: string) {
    super(url);
  }

  async searchGifs(request: ISearchGifsRequest): Promise<IGifList> {
    const query = new URLSearchParams();

    request.type && query.append("type", request.type);
    request.order && query.append("order", request.order);
    request.count && query.append("count", request.count.toString());
    request.page && query.append("page", request.page.toString());
    request.query && query.append("query", request.query);
    request.verified && query.append("verified", "y");
    request.tags && query.append("tags", request.tags.join(","));

    return await this.get(`v2/gifs/search?${query.toString()}`);
  }

  async getTagsSearches(query: string): Promise<ITagsList[]> {
    return await this.get(`v2/search/suggest?query=${encodeURI(query)}`);
  }

  async getHistorySearches(): Promise<THistoryList> {
    return await this.get("v2/search/user-history");
  }

  async removeAllHistorySearches(): Promise<void> {
    return await this.delete("v2/search/user-history");
  }

  async removeHistorySearchItem(id: string): Promise<void> {
    return await this.delete(`v2/search/user-history/${id}`);
  }

  async addHistorySearchItem(data: IAddToHistory): Promise<void> {
    return await this.post("v2/search/user-history", data);
  }

  async getTopThisWeek(): Promise<IGifList> {
    return await this.get("v2/explore/top-this-week");
  }

  async getTrendingGifs(): Promise<IGifList> {
    return await this.get("v2/explore/trending-gifs");
  }

  async getTrendingImages(): Promise<IGifList> {
    return await this.get("v2/explore/trending-images");
  }
}
